<template>
<v-container fluid>
  <v-card>
    <v-card-title>
      <div class="flex-grow-1">        
        Encuestas
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              icon
              color="primary"
              class="px-0"        
              v-bind="attrs"
              v-on="on" 
              @click="obtenerEncuestas"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Refrescar información de la tabla</span>
        </v-tooltip>
      </div>
      <div class="flex-grow-1">
        <dialog-form-encuesta v-if="permisoCrear"  name="dfs_0" :id-accion="1" :fn-on-save="obtenerEncuestas"></dialog-form-encuesta>
      </div>        
      <div class="flex-grow-1">
        <v-row justify="end">
          <v-col 
            cols="12" 
            sm="5"
          >
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              hide-details
              outlined
              dense
            />
          </v-col>
        </v-row>
      </div>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :search="search"
        calculate-widths
        loading-text="Cargando... Por favor espere"
        locale="es-ES"
      >
       <template v-slot:item.fechaInicio="{ item }">
          {{ getDateFormated(item.fechaInicio) }}
        </template>
        <template v-slot:item.fechaFin="{ item }">
          {{ getDateFormated(item.fechaFin) }}
        </template>
        <template v-slot:item.habilitada="{ item }">
          <v-icon :color="item.habilitada ? 'green' : 'red'">
            {{ item.habilitada ? 'mdi-check' : 'mdi-close' }}
          </v-icon>
        </template>
      <template v-slot:item.fechaRegistro="{ item }">
          {{ getDateFormated(item.fechaRegistro) }}
        </template>
        <template v-slot:item.encuestas="{ item }">
          <v-avatar
            color="indigo"
            size="25"
          >
            <span class="white--text text-h6">{{item.eiEncuesta.length}}</span>
          </v-avatar>
        </template>
        <template v-slot:item.acciones="{ item, item2 }">
          <v-row>
            <v-col cols="12" style="display:ruby;">            
              <dialog-roles v-if="permiso" :obj-encuesta="item" ></dialog-roles>
              <dialog-form-encuesta v-if="permisoCrear" :name="'dfs_' + item.idEncuesta" :id-accion="2" :obj-encuesta="item" :fn-on-save="obtenerEncuestas"></dialog-form-encuesta>
              <button-inicio-disenar-encuesta v-if="isInEncuestasDisenio(item.idEncuesta)" :id-servicio="item.idCatServicio" :id-encuesta="item.idEncuesta" :token-encuesta="item.tokenEncuesta"></button-inicio-disenar-encuesta>
              <dialog-participantes v-if="isInEncuestasAplicar(item.idEncuesta) && item.idSistemaEncuesta == null"  :obj-encuesta="item" ></dialog-participantes>
              <dialog-compartir v-if="item.idSistemaEncuesta == null" :obj-encuesta="item" ></dialog-compartir>
              <dialog-consultar v-if="isInEncuestasConsultar(item.idEncuesta)"  :obj-encuesta="item"  ></dialog-consultar>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
  <v-snackbar
    key="snackbarDataTableEncuestas"
    v-model="snackbar"
    :bottom="true"
    :multi-line="true"
    :color="snackbarColor"
  >
    {{ snackbarTexto }}
    <v-btn dark text @click="snackbar = false;">
      Cerrar
    </v-btn>
  </v-snackbar> 
</v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { getEncuestas, obtenerGruposParticipanteEncuesta } from "@/api";
import moment from 'moment';
  import { format, parseISO } from 'date-fns'

export default {
  name: "DataTableEncuestas",
 components: {
    DialogRoles: () => import("../bandejaEncuestas/DialogRoles"),
    FormEncuesta:()=>import("../bandejaEncuestas/DialogFormEncuesta"),
    ButtonInicioDisenarEncuesta:()=>import("../disenarEncuesta/ButtonInicioDisenarEncuesta"),
    DialogFormEncuesta:()=>import("../bandejaEncuestas/DialogFormEncuesta"),
    DialogParticipantes:()=>import("../bandejaEncuestas/DialogParticipantes"),
    DialogCompartir:()=>import("../bandejaEncuestas/DialogCompartir"),
    DialogConsultar:()=>import("../bandejaEncuestas/DialogConsultar"),
  },
  props: {
    flagReload: {
      type: Number,
      default: 0
    },
    fnOnLoaded: {
      type: Function,
      default: () => {}
    },
  },
  data () {
    return {
      loading: true,
      snackbar: false,
      snackbarColor: '',
      snackbarTexto: '',
      headers: [
        { align: "left", text: "Nombre Encuesta", value: "nombreEncuesta" }, 
        { align: "left", text: "Objetivo", value: "objetivo" },
        { align: "left", text: "Fecha inicio", value: "fechaInicio" },
        { align: "left", text: "Fecha fin", value: "fechaFin" },
        { align: "left", text: "Habilitada", value: "habilitada" },
        { align: "center", text: "Fecha de Registro", value: "fechaRegistro" },
        { align: "center", text: "Acciones", value: "acciones" }
      ],
      items: [],
      itemsFilter: [],
      search: "",
      dialog: false,
      itemSelected: {},
      permiso: false,
      permisoCrear: false,
      idsEncuestasDisenio: [],
      idsEncuestasAplicar: [],
      idsEncuestasConsultar:[],

      enviarFecha:'',
    };
  },
  computed: {
  },
  watch: {
    flagReload: {
      handler (newValue, oldValue) {
        this.obtenerEncuestas();
			},
    },
  },
 async mounted () {
    if(await this.tienePermisoServicio({permiso: 'Administrador Encuestas'})==true ||
    await this.tienePermisoServicio({permiso: 'Coordinador'})==true){
      this.permisoCrear=true;
      this.permiso=true;
    }
  this.obtenerEncuestas();
  },
  methods: {
 ...mapActions(['tienePermisoServicio', 'tieneRolEncuesta']),
    async obtenerEncuestas () {
      
      console.log(this.enviarFecha);
      var self = this;
      self.loading = true;
      self.items = [];
      self.itemsFilter = [];
      self.idsEncuestasDisenio = [];
      self.snackbarError = false;
      self.textoError = "";
      try {
        let response = await getEncuestas();
        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              self.items = response.data.data;

              self.items.forEach(async function(item) {
                if(await self.tieneRolEncuesta({idEncuesta: item.idEncuesta, rol: 'Diseñar'})){
                  self.idsEncuestasDisenio.push(item.idEncuesta);
                }
                if(await self.tieneRolEncuesta({idEncuesta: item.idEncuesta, rol: 'Aplicar'})){
                  self.idsEncuestasAplicar.push(item.idEncuesta);
                }
                if(await self.tieneRolEncuesta({idEncuesta: item.idEncuesta, rol: 'Consultar'})){
                  self.idsEncuestasConsultar.push(item.idEncuesta);
                }
              });

              self.loading = false;
            }
          } else {
            self.snackbarTexto = "DataTableEncuestas: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loading = false;
          }
        } else {
          self.snackbarTexto = "DataTableEncuestas: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loading = false;
        }
      } catch (e) {
        self.loading = false;
        self.snackbarTexto = "DataTableEncuestas: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },

    
    getDateFormated(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY hh:mm a');
      }
    },
    isInEncuestasDisenio(idEncuesta){
      var isIn = this.idsEncuestasDisenio.filter(n=>n == idEncuesta)[0];

      if(isIn == undefined){
        return false;
      }
      else{
        return true;
      }
    },
    isInEncuestasAplicar(idEncuesta){
      var isIn = this.idsEncuestasAplicar.filter(n=>n == idEncuesta)[0];

      if(isIn == undefined){
        return false;
      }
      else{
        return true;
      }
    },
  isInEncuestasConsultar(idEncuesta){
      var isIn = this.idsEncuestasConsultar.filter(n=>n == idEncuesta)[0];

      if(isIn == undefined){
        return false;
      }
      else{
        return true;
      }
  }
  }
};
</script>
